import { css as a, LitElement as s, html as o } from "lit";
import { property as p, customElement as d } from "lit/decorators.js";
import { classMap as x } from "lit/directives/class-map.js";
import { b as l } from "./styles-scZ6dVz-.js";
var k = Object.defineProperty, w = Object.getOwnPropertyDescriptor, r = (i, n, v, c) => {
  for (var e = c > 1 ? void 0 : c ? w(n, v) : n, f = i.length - 1, h; f >= 0; f--)
    (h = i[f]) && (e = (c ? h(n, v, e) : h(e)) || e);
  return c && e && k(n, v, e), e;
};
let t = class extends s {
  constructor() {
    super(...arguments), this.elevated = !1, this.interactive = !1, this.bordered = !1, this.flat = !1;
  }
  render() {
    const i = {
      card: !0,
      elevated: this.elevated,
      interactive: this.interactive,
      bordered: this.bordered,
      flat: this.flat
    };
    return o`
      <div part="card" class=${x(i)}>
        <slot></slot>
      </div>
    `;
  }
};
t.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .card {
        background-color: var(--r5-card-bg, var(--r5-bg));
        border: 1px solid var(--r5-card-border-color, var(--r5-border));
        border-radius: var(--r5-card-radius, var(--r5-radius-lg));
        box-shadow: var(--r5-card-shadow, var(--r5-shadow-sm));
        overflow: hidden;
      }

      .card.elevated {
        box-shadow: var(--r5-shadow-md);
      }

      .card.interactive {
        cursor: pointer;
        transition: box-shadow var(--r5-duration-fast) var(--r5-ease-default),
                    transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .card.interactive:hover {
        box-shadow: var(--r5-shadow-lg);
        transform: translateY(-1px);
      }

      .card.interactive:active {
        transform: translateY(0);
      }

      .card.bordered {
        box-shadow: none;
      }

      .card.flat {
        border: none;
        box-shadow: none;
        background-color: var(--r5-bg-subtle);
      }
    `
];
r([
  p({ type: Boolean, reflect: !0 })
], t.prototype, "elevated", 2);
r([
  p({ type: Boolean, reflect: !0 })
], t.prototype, "interactive", 2);
r([
  p({ type: Boolean, reflect: !0 })
], t.prototype, "bordered", 2);
r([
  p({ type: Boolean, reflect: !0 })
], t.prototype, "flat", 2);
t = r([
  d("ark-card")
], t);
let b = class extends s {
  render() {
    return o`
      <div part="header" class="header">
        <slot></slot>
      </div>
    `;
  }
};
b.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .header {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1-5);
        padding: var(--r5-space-6);
        padding-bottom: 0;
      }
    `
];
b = r([
  d("ark-card-header")
], b);
let u = class extends s {
  render() {
    return o`
      <h3 part="title" class="title">
        <slot></slot>
      </h3>
    `;
  }
};
u.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .title {
        font-size: var(--r5-text-lg);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        line-height: var(--r5-leading-tight);
        margin: 0;
      }
    `
];
u = r([
  d("ark-card-title")
], u);
let m = class extends s {
  render() {
    return o`
      <p part="description" class="description">
        <slot></slot>
      </p>
    `;
  }
};
m.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .description {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-normal);
        margin: 0;
      }
    `
];
m = r([
  d("ark-card-description")
], m);
let g = class extends s {
  render() {
    return o`
      <div part="content" class="content">
        <slot></slot>
      </div>
    `;
  }
};
g.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .content {
        padding: var(--r5-space-6);
      }
    `
];
g = r([
  d("ark-card-content")
], g);
let y = class extends s {
  render() {
    return o`
      <div part="footer" class="footer">
        <slot></slot>
      </div>
    `;
  }
};
y.styles = [
  l,
  a`
      :host {
        display: block;
      }

      .footer {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-6);
        padding-top: 0;
      }
    `
];
y = r([
  d("ark-card-footer")
], y);
export {
  t as A,
  b as a,
  u as b,
  m as c,
  g as d,
  y as e
};
//# sourceMappingURL=ark-card-UUM1tAqX.js.map
